// Outside lookups for a review row's company.

// Google for the company's name and address: street when we have one, then
// city, state, country and zip.
export function googleSearchUrl(company) {
    const q = [company.company_name, company.full_address].filter(Boolean).join(' ')
    return `https://www.google.com/search?q=${encodeURIComponent(q)}`
}

// The CAGE code on cage.report (the mirror discovery reads registered websites
// and emails from) and on DLA's own CAGE search.
export function cageLinks(cageCode) {
    if (!cageCode) return []
    const code = encodeURIComponent(cageCode)
    return [
        { label: 'cage.report', url: `https://cage.report/CAGE/${code}` },
        { label: 'DLA CAGE', url: `https://cage.dla.mil/Search/Results?q=${code}&page=1` },
    ]
}
